import React, { FC } from "react";
import { Field } from "react-final-form";
import makeStyles from "@material-ui/core/styles/makeStyles";
import WeduCheckbox from "../../../../../components/WeduCheckbox/WeduCheckbox";
import InputLabel from "@material-ui/core/InputLabel";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { FieldArrayRenderProps } from "react-final-form-arrays";
import { CourseHousingType as Housing } from "../../../types";

const useStyles = makeStyles(() => ({
  container: {
    width: 328,
    "& .MuiIconButton-root": {
      padding: "0px 9px !important",
    },
  },
  checkboxGroup: {
    display: "flex",
    justifyContent: "space-between",
    "& > .MuiFormControlLabel-root:first-child": {
      marginLeft: -9,
    },
    "& > .MuiFormControlLabel-root": {
      marginRight: 0,
    },
  },
}));

interface IHousingTypeProps extends FieldArrayRenderProps<any, HTMLElement> {
  disabled: boolean;
  errors: { [key: string]: string };
}

const HousingType: FC<IHousingTypeProps> = ({
  fields: { name },
  errors,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <div>
      <FieldsGroupLabel
        isRequired={!disabled}
        label="Housing Type"
        hasError={!!errors.housingTypes}
        className="fields-group-label"
      />
      <div className={classes.container}>
        <div className={classes.checkboxGroup}>
          <Field
            value={Housing.RESIDENCE}
            label="Residence"
            type="checkbox"
            name={name}
            disabled={disabled}
            component={WeduCheckbox}
          />
          <Field
            value={Housing.HOMESTAY}
            label="Homestay"
            type="checkbox"
            name={name}
            disabled={disabled}
            component={WeduCheckbox}
          />
          <Field
            value={Housing.NO_HOUSING}
            label="No Housing"
            type="checkbox"
            name={name}
            disabled={disabled}
            component={WeduCheckbox}
          />
        </div>
        {!!errors.housingTypes && (
          <InputLabel className="field-error-text">
            {errors.housingTypes}
          </InputLabel>
        )}
      </div>
    </div>
  );
};

export default HousingType;
